import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce872838"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Indisch Monument Admin", -1))
const _hoisted_3 = {
  key: 0,
  class: "admin-data"
}
const _hoisted_4 = { class: "admin-data-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Melati's", -1))
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Titel"),
  /*#__PURE__*/_createElementVNode("th", null, "Tekst"),
  /*#__PURE__*/_createElementVNode("th", null, "Van"),
  /*#__PURE__*/_createElementVNode("th", null, "Thema's"),
  /*#__PURE__*/_createElementVNode("th", null, "Aangemaakt"),
  /*#__PURE__*/_createElementVNode("th", null, "ID"),
  /*#__PURE__*/_createElementVNode("th", null, "Verwijder")
], -1))
const _hoisted_8 = { class: "nowrap" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "error-message"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "outline-btn"
}, "Inloggen", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadMelatiCsv = _resolveComponent("DownloadMelatiCsv")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.authenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("header", _hoisted_4, [
            _createVNode(_component_DownloadMelatiCsv),
            _hoisted_5,
            _createElementVNode("button", {
              class: "logout-btn outline-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
            }, "Uitloggen")
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Er is iets misgegaan met het ophalen van de Melati's."))
            : _createCommentVNode("", true),
          _createElementVNode("table", null, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexes, (index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index.id
              }, [
                _createElementVNode("td", null, _toDisplayString(index.title), 1),
                _createElementVNode("td", null, _toDisplayString(index.text || '-'), 1),
                _createElementVNode("td", null, _toDisplayString(index.from || '-'), 1),
                _createElementVNode("td", null, _toDisplayString(index.tags?.map(tag => tag.title).join(', ') || '-'), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.formatDateString(index.created)), 1),
                _createElementVNode("td", null, _toDisplayString(index.id), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    onClick: () => _ctx.deleteMessage(index.id),
                    class: "delete-btn"
                  }, "×", 8, _hoisted_9)
                ])
              ]))
            }), 128))
          ]),
          (!_ctx.allFetched)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "outline-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getMessageIndexes && _ctx.getMessageIndexes(...args)))
              }, "Meer melati's laden"))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "admin-login",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args)), ["prevent"]))
        }, [
          _createElementVNode("label", null, [
            _createTextVNode(" Email"),
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "email",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.user.email]
            ])
          ]),
          _createElementVNode("label", null, [
            _createTextVNode(" Wachtwoord"),
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user.password) = $event))
            }, null, 512), [
              [_vModelText, _ctx.user.password]
            ])
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Dit account is niet bij ons bekend."))
            : _createCommentVNode("", true),
          _hoisted_13
        ], 32))
  ]))
}